import { hasCapability, type User } from "../base";

export const financeAdminTools = {
  read: (user: User) => hasCapability(user, "financeAdminTools.read"),
  update: (user: User) => hasCapability(user, "financeAdminTools.update"),
};
